import { FormControl, MenuItem, Select } from "@material-ui/core";
import { useStyles } from "../../../assets/jss/PraisoTable";
import { useTranslation } from "react-i18next";
import { EventTypes } from "../../../config/app-globals.enum";
import React, { useState, useContext, useEffect } from 'react';
import UserContext from "../../../context/UserContext";
import { setReportedEventDropDownIndex, getReportedEventDropDownIndex, getVisibleEventDetails, getIsCameFromEventDetailsPage } from "../../../services/LocalStorageService";
export default function GlobalDropDown(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const { eventCategory, setEventCategory } = useContext(UserContext);
    const [value, setValue] = React.useState(eventCategory);
    const [dropDownItems, setDropDownItems] = useState(getVisibleEventDetails());
    function handleChange(e) {
        setValue(e.target.value);
        setEventCategory(e.target.value);
        setReportedEventDropDownIndex(e.target.value);
    }

    useEffect(() => {
        const index = dropDownItems.indexOf(String("TRIPS"));
        if (index > 0)
            dropDownItems.splice(index, 1);
        // if (getReportedEventDropDownIndex() === undefined || getReportedEventDropDownIndex() !== null || getReportedEventDropDownIndex() === 0) {
        //     setReportedEventDropDownIndex(eventType.SPEEDING);
        // }
        if (getIsCameFromEventDetailsPage() !== undefined && getIsCameFromEventDetailsPage() !== null && getIsCameFromEventDetailsPage() === 0) {
            //setReportedEventDropDownIndex(eventType.SPEEDING);
            setEventCategory((getReportedEventDropDownIndex() === null) ? EventTypes.SPEEDING : getReportedEventDropDownIndex());
            setValue((getReportedEventDropDownIndex() === null) ? EventTypes.SPEEDING : getReportedEventDropDownIndex());
        } else if (getIsCameFromEventDetailsPage() === 1) {
            setEventCategory((getReportedEventDropDownIndex() === null) ? EventTypes.SPEEDING : getReportedEventDropDownIndex());
            setValue((getReportedEventDropDownIndex() === null) ? EventTypes.SPEEDING : getReportedEventDropDownIndex());
        }

    }, [dropDownItems]);

    function getEventType(item: string) {
        let val = 0;
        const events = Object.values(EventTypes);
        if (item === "SPEEDING") {
            val = EventTypes.SPEEDING;
        } else if (item === "BRAKING") {
            val = EventTypes.BRAKING;
        } else if (item === "CORNERING") {
            val = EventTypes.CORNERING;
        } else if (item === "ACCELERATION") {
            val = EventTypes.ACCELERATION;
        } else if (item === "DISTRACTION") {
            val = EventTypes.DISTRACTION;
        } else if (item === "DRIVER_DISTRACTION") {
            val = EventTypes.DISTRACTION;
        }
        if (events.find(element => element == val) !== undefined)
            return val;
    }

    return (
        <>
            <FormControl className={classes.eventDropDown}>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={value}
                    onChange={handleChange}
                >
                    {dropDownItems.map((item) => (
                        <MenuItem key={getEventType(item)} value={getEventType(item)}>{item === "DRIVER_DISTRACTION" ? t('DISTRACTION') : t(String(item))}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
}

function EventContext(EventContext: any) {
    throw new Error("Function not implemented.");
}
